export default "__VITE_ASSET__14a0d10b__"